import React from "react";
import Card from "react-bootstrap/Card";
import { AiFillMail } from "react-icons/all";
import { AiFillPhone } from "react-icons/all";
import { IoLogoWhatsapp } from "react-icons/all";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            <span className="purple">
              I’m a hard working and dedicated professional web developer and
              user interface designer.
            </span>
            <br />
            <br />
            <span className="purple">
              The main areas of my expertise are HTML5, CSS3, SASS, and
              JavaScript. but I have knowledge of mongodb and back-end
              technologies.
            </span>
            <br />
            <br />
            <span className="purple">
              I have worked with a number of projects and I am comfortable
              working under pressure to complex specifications.
            </span>
            <br />
            <br />
            <span className="purple">
              I regularly use version control systems to maintain my code and I
              specialise in responsive web design.
            </span>
          </p>
          <ul>
            <li className="about-activity">
              <AiFillMail id="icon" />{" "}
              <a id="link" href="mailto:rekhilelias2014@gmail.com">
                rekhilelias2014@gmail.com
              </a>
            </li>

            <li className="about-activity">
              <AiFillPhone id="icon" />{" "}
              <a id="link" href="tel:+918304094652 ">
                +918304094652
              </a>
            </li>

            <li className="about-activity">
              <IoLogoWhatsapp id="icon" />{" "}
              <a id="link" href="https://wa.me/+918304094652">
                WhatsApp
              </a>
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
